import type { ReactElement } from 'react';
import React from 'react';

interface ImageProps {
  src: string;
  title: string;
  alt: string;
  width: number;
  height: number;
  className?: string;
  loading: 'eager' | 'lazy';
}

export const Image = (props: ImageProps): ReactElement => {
  return (
    <img
      src={props.src}
      title={props.title}
      alt={props.alt}
      aria-label={props.alt}
      width={props.width}
      height={props.height}
      loading={props.loading}
      className={props.className}
    />
  );
};
